import contactInfo_en from './contact-info_en.json'

const nua_resources = {
  en: {
    ...contactInfo_en,
  },
}

export default nua_resources
